// removed by extract-text-webpack-plugin
module.exports = {"container_drop":"styles__container_drop___2n25v","file_info":"styles__file_info___3nnbU","files_attachment":"styles__files_attachment___2UxCp","button_remove":"styles__button_remove___m4tLy","box_drop":"styles__box_drop___qulvW","area_attach_valid":"styles__area_attach_valid___1wvWp","area_attach_invalid":"styles__area_attach_invalid___3oKww","uploadContainer":"styles__uploadContainer___1pAgv","uploadText":"styles__uploadText___3Sl08","send":"styles__send___ShzdI","confirmButton":"styles__confirmButton___3UDrb"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Inputs/DropFile/styles.css
// module id = 3212
// module chunks = 0